<template>
  <span>
    {{ getShowingText() }}
  </span>
</template>

<script>
import filterProfaneWords from './filterProfaneWords'

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    filteringProfanity: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    getShowingText() {
      if (!this.filteringProfanity) {
        return this.text
      }
      if (!this.text) return ''
      return filterProfaneWords(this.text)
    },
  },
}
</script>
